module.exports = __webpack_public_path__ + "static/media/google-icon.d6d98c53.svg";